import { mapState } from 'vuex';
import { showError } from '@/helpers/globalHelpers';

const STORAGE_KEY = 'permissions_dashboard_meta';

export default {
	name: 'PermissionsDashboard',
	data() {
		return {
			metaTicketsResueltos: 80,
			metaSatisfaccion: 100,
		};
	},
	created() {
		this.loadFromLocalStorage();
	},
	computed: {
		...mapState('dashboardPermissions', ['loadingReport']),
		breadcrumbs() {
			return [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'Dashboard' },
				},
				{
					text: 'Permisos de Aplicación',
					link: true,
					exact: true,
					disabled: false,
					to: { name: 'PermissionHomePage' },
				},
				{
					text: 'Dashboard',
					link: true,
					exact: true,
					disabled: true,
				},
			];
		},
	},
	methods: {
		loadFromLocalStorage() {
			try {
				const saved = localStorage.getItem(STORAGE_KEY);
				if (saved) {
					const data = JSON.parse(saved);
					if (data.metaTicketsResueltos != null) {
						this.metaTicketsResueltos = data.metaTicketsResueltos;
					}
					if (data.metaSatisfaccion != null) {
						this.metaSatisfaccion = data.metaSatisfaccion;
					}
				}
			} catch (e) {
				// Si hay error al leer localStorage, se usan los valores por defecto
			}
		},
		saveToLocalStorage() {
			localStorage.setItem(
				STORAGE_KEY,
				JSON.stringify({
					metaTicketsResueltos: this.metaTicketsResueltos,
					metaSatisfaccion: this.metaSatisfaccion,
				})
			);
		},
		async generarReporte() {
			try {
				await this.$store.dispatch('dashboardPermissions/exportDashboardReport', {
					porcentaje_meta_resueltos: this.metaTicketsResueltos,
					porcentaje_meta_satisfaccion: this.metaSatisfaccion,
				});
			} catch (error) {
				showError(error);
			}
		},
	},
};
